import React, { useEffect, useState } from "react";

const Charts = () => {
  // 🌟 第一步：所有的 Hooks 必须放在最顶层！(React 铁律)
  const [ready, setReady] = useState(false);
  const DASHBOARD_VERSION = "20240207";

  useEffect(() => {
    // 只做延迟渲染
    const t = setTimeout(() => setReady(true), 100);
    return () => clearTimeout(t);
  }, []);

  // 🌟 第二步：Hooks 声明完之后，再进行条件判断和提前返回
  // 检测当前是否在 iframe 中，如果是，立刻阻断渲染！
  if (window !== window.top) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
        <p style={{ color: "red" }}>图表加载失败：已被安全拦截重定向。请检查后端 /static 权限配置。</p>
      </div>
    );
  }

  // 等待延迟加载
  if (!ready) {
    return <div style={{ height: "100%" }} />;
  }

  const backendUrl = process.env.REACT_APP_BASE_URL || "";

  return (
      <div style={{ width: "100%", height: "100vh" }}>
          <iframe
              src={`${backendUrl}/static/dashboard.html?v=${DASHBOARD_VERSION}`}
              title="ETCarbon Charts Dashboard"
              style={{
                  width: "100%",
                  height: "100%",
                  border: "none"
              }}
          />
      </div>
  );
};

export default Charts;